import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { FormControl, FormLabel } from '@material-ui/core';
import { type IGenericInput } from 'src/models';
import { makeStyles } from '@material-ui/core/styles';
import CalendarIcon from '@material-ui/icons/Event';
import MomentUtils from '@date-io/moment';
import esLocale from 'date-fns/locale/es';
import moment from 'moment';
import { type MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

const useStyles = makeStyles(() => ( {
	input: {
		background: '#fff',
		fontWeight: 500,
	},
	textField: {
		background: '#fff',
		fontWeight: 500,
	},
} ));

export function DateInput( props: IGenericInput ) {
	const classes = useStyles();
	const { label, name, onChange, value, ...rest } = props;

	const onChangeHandler = (date: MaterialUiPickersDate) => {
		const change = {
			target: {
				name,
				value: moment(date).format('YYYY/MM/DD'),
			},
		}
		// @ts-ignore
		onChange(change);
	}

	return (
		<FormControl fullWidth>
			<FormLabel htmlFor={name}> {label} </FormLabel>

			<MuiPickersUtilsProvider locale={'es'} utils={MomentUtils}>
				<DatePicker
					{...rest}
					InputProps={{
						endAdornment: <CalendarIcon/>,
					}}
					autoOk
					format={'DD/MM/YYYY'}
					inputVariant={'outlined'}
					onChange={onChangeHandler}
					size={'small'}
					value={value}
				/>
			</MuiPickersUtilsProvider>
		</FormControl>
	);
}
